import { useTranslation } from 'react-i18next'

import { wwtMemo } from '@wwt/custom/wwt'

import { Offer } from '@wwt/entities/search-response'

import { ButtonProps } from '@/shared/ui/Button'
import { Button } from '@/shared/ui/Button.tsx'

import { usePay } from '../model/usePay.ts'

interface PayButtonProps extends ButtonProps {
	className?: string
	offer: Offer | null
}

export const PayButton = wwtMemo(
	({ className, offer, ...props }: PayButtonProps) => {
		const { t } = useTranslation('room-page')

		const { paymentLink, isDisabled } = usePay(offer)

		return (
			<Button
				className={className}
				data-wwt-id="room-offer__pay-button--unique"
				variant="default"
				size="lg"
				key="pay-button"
				title={t('pay', { ns: 'tooltips' })}
				asChild
				data-disabled={isDisabled}
				{...props}
			>
				<a href={paymentLink}>{t('pay')}</a>
			</Button>
		)
	}
)
